import {
  Button,
  DialogClose,
  InterceptDialog,
  Typography,
} from "@hellocarbo/lasagne";
import { use } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { PortalContainerContext, UserContext } from "@/contexts";
import useOutboundQueryParams from "@/hooks/useOutboundQueryParams";
import useSegmentEvent from "@/hooks/useSegmentEvent";

const UpsellModal = ({ children }: { children: React.ReactNode }) => {
  const { user } = use(UserContext);
  const { t } = useTranslation("communicate");
  const outboundQueryParams = useOutboundQueryParams("freetrial");
  const { sendSegmentEvent } = useSegmentEvent();

  const { container } = use(PortalContainerContext);

  return (
    <InterceptDialog
      show={user?.company.subscriptionType === "start"}
      title={t("freeTrial.modal.title")}
      warningMessage={t("freeTrial.modal.warning")}
      portalContainer={container as Element}
      content={<Typography>{t("freeTrial.modal.content")}</Typography>}
      footer={
        <>
          <DialogClose asChild>
            <Button
              shape="link"
              as={Link}
              to="/pricing"
              onClick={() => {
                sendSegmentEvent("Discover the plans", {
                  size: `${user?.company.employees}`,
                });
              }}
            >
              {t("freeTrial.modal.secondaryAction")}
            </Button>
          </DialogClose>
          <DialogClose asChild>
            <Button
              shape="solid"
              as="a"
              href={`https://www.hellocarbo.com/reservez-votre-demo${outboundQueryParams}`}
              onClick={() => {
                sendSegmentEvent("Subscription Asked", {
                  size: `${user?.company.employees}`,
                });
              }}
              shouldOpenNewTab
            >
              {t("freeTrial.modal.primaryAction")}
            </Button>
          </DialogClose>
        </>
      }
    >
      {children}
    </InterceptDialog>
  );
};

export default UpsellModal;
